import { ImportFile } from './ImportFile';

export default ImportFile;
